<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronLeftIcon from "svelte-material-icons/ChevronLeft.svelte"

    export let backlink = "/cart"
    export let backtitle = $_("checkout.back")
    export let nexttitle = $_("checkout.next")
    export let nextComponent = null
    export let submitDisabled = false
    export let submitHandler: () => void = null
</script>

<div class="checkout_bottom">
    <a href="{backlink}" class="linkback"
        ><span class="icon"><ChevronLeftIcon size="24" /></span>
        {backtitle}</a
    >
    {#if nextComponent}
        {#if submitDisabled}
            <button type="button" class="btn btn-secondary" disabled="{submitDisabled}">{nexttitle}</button>
        {:else}
            <svelte:component this="{nextComponent}" submitHandler="{submitHandler}" />
        {/if}
    {:else if nexttitle}
        <button type="submit" class="btn btn-secondary" disabled="{submitDisabled}">{nexttitle}</button>
    {/if}
</div>

<style lang="less">
    button:disabled {
        opacity: 0.1;
    }

    @media (max-width: 800px) {
        .checkout_bottom {
            flex-flow: column;

            .linkback {
                margin-top: 50px;
                order: 1;
            }
        }
    }
</style>
